"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateAppConfig = function (user) {
    var config = {};
    var gates = user.gates;
    var isBotsV2User = utils_1.getIsBotsV2User(gates);
    var needsToUpgradeForMarketo = ramda_1.pathOr(false, ['marketo_prompt_upgrade'], gates);
    config = ramda_1.set(ramda_1.lensProp('hasEnrollInSequence'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasSendMessageButton'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasAccountsSubNav'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasLiveViewSubNav'), !isBotsV2User, config);
    if (isBotsV2User) {
        config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), true, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), !needsToUpgradeForMarketo, config);
    }
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/contactsWeb/index.js
// module id = ee4C
// module chunks = 88